
import { useEffect, useState } from "react";
import CollectionGrid from "@/components/dashboard/CollectionGrid";
import { ARCHIVE_ID } from "@/utils/contentFormUtils";
import EditContentDialog from "@/components/dashboard/EditContentDialog";
import { usePersistentViewMode } from "@/hooks/usePersistentViewMode";
import { useCollections } from "@/contexts/collections";

const Archive = () => {
  const [selectedContentId, setSelectedContentId] = useState<string | null>(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState("");
  const { viewMode, setViewMode } = usePersistentViewMode();
  const { refreshCollections } = useCollections();
  
  // Force collection refresh on every mount
  useEffect(() => {
    refreshCollections();
  }, [refreshCollections]);

  useEffect(() => {
    document.title = "Archive - Clustr";
  }, []);

  const handleEditContent = (contentId: string, title: string) => {
    setSelectedContentId(contentId);
    setCurrentTitle(title);
    setEditDialogOpen(true);
  };

  const archiveDescription = "Content you've archived for later reference";

  return (
    <div className="flex-1 flex flex-col h-full">
      <main className="flex-1 overflow-y-auto h-full">
        <CollectionGrid 
          title="Archive"
          description={archiveDescription}
          collectionId={ARCHIVE_ID}
          collectionColor="#ECEDF0" // Light grey for archive
          isArchive={true}
          onEditContent={handleEditContent}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
        />
        
        {selectedContentId && (
          <EditContentDialog
            contentId={selectedContentId}
            title={currentTitle}
            isOpen={editDialogOpen}
            onOpenChange={setEditDialogOpen}
          />
        )}
      </main>
    </div>
  );
};

export default Archive;
